/* eslint-disable */
import  { useState } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import { useLocation } from "react-router-dom";
import ButtonGroup from "@mui/material/ButtonGroup";
import AddIcon from "@mui/icons-material/Add";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import RemoveIcon from "@mui/icons-material/Remove";
import Layout from "../components/layout/Layout";
import CustomDrawer from "../components/CustomDrawer";

// Import chart components
import SalesChart1 from "../components/SalesChart1";
import SalesChart2 from "../components/SalesChart2";
import SalesChart3 from "../components/SalesChart3";
import SalesChart4 from "../components/SalesChart4";

const SalesDashboard2 = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [, setAnchorEl] = useState(null);
  const location = useLocation();
  
  // Use optional chaining to safely access location.state.name
  const name = location?.state?.name || "";

  const handleDownloadClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  // Add error boundaries around chart components to make debugging easier
  const renderChartWithErrorHandling = (ChartComponent) => {
    try {
      return <ChartComponent />;
    } catch (error) {
      console.error(`Error rendering chart: ${error.message}`);
      return <div>Error loading chart: {error.message}</div>;
    }
  };

  return (
    <Layout>
      <div>
        {name && <h1 className="ms-5">{name}</h1>}
        <Box
          sx={{
            position: "fixed",
            top: 0,
            right: 0,
            m: 5,
            zIndex: 1300,
          }}
        >
          <ButtonGroup
            sx={{
              marginTop: 3,
              marginLeft: 7,
              justifyItems: "center",
              backgroundColor: "#FD6262",
            }}
            variant="contained"
            aria-label="Basic button group"
          >
            <Button
              sx={{
                backgroundColor: "#FD6262",
                display: "flex",
                justifyItems: "center",
                alignItems: "center",
                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
            >
              <RemoveIcon />
            </Button>
            <Button
              sx={{
                backgroundColor: "#FD6262",
                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
            >
              <AddIcon />
            </Button>
            <Button
              sx={{
                backgroundColor: "#FD6262",
                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
              onClick={handleDownloadClick}
            >
              <ArrowCircleDownIcon />
            </Button>
            <Button
              sx={{
                backgroundColor: "#FD6262",
                "&:hover": { backgroundColor: "#FF4D4D" },
              }}
              onClick={handleDrawerToggle}
            >
              <RemoveRedEyeIcon />
            </Button>
          </ButtonGroup>
        </Box>
        <CustomDrawer
          isDrawerOpen={isDrawerOpen}
          handleDrawerToggle={handleDrawerToggle}
        />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: "100%",
            paddingTop: "64px",
            paddingRight: isDrawerOpen ? "20%" : "0px",
          }}
        >
          <Toolbar /> 
          <Box component="section" mt={4}>
            <Container>
              <Grid
                container
                spacing={4}
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                <Grid item xs={12} md={6} style={{ display: "flex" }}>
                  <Paper
                    sx={{ padding: 4, backgroundColor: "#e0e0e0", flex: 1 }}
                    elevation={3}
                  >
                    {renderChartWithErrorHandling(SalesChart1)}
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6} style={{ display: "flex" }}>
                  <Paper
                    sx={{ padding: 4, backgroundColor: "#d0d0d0", flex: 1 }}
                    elevation={3}
                  >
                    {renderChartWithErrorHandling(SalesChart4)}
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6} style={{ display: "flex" }}>
                  <Paper
                    sx={{ padding: 4, backgroundColor: "#c0c0c0", flex: 1 }}
                    elevation={3}
                  >
                    {renderChartWithErrorHandling(SalesChart3)}
                  </Paper>
                </Grid>
                <Grid item xs={12} md={6} style={{ display: "flex" }}>
                  <Paper
                    sx={{ padding: 4, backgroundColor: "#b0b0b0", flex: 1 }}
                    elevation={3}
                  >
                    {renderChartWithErrorHandling(SalesChart2)}
                  </Paper>
                </Grid>
              </Grid>
            </Container>
          </Box>
        </Box>
      </div>
    </Layout>
  );
};

export default SalesDashboard2;
